// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `// Cartao

.ui-card__container {
  padding: 1.07692em 0.61538em;
}

.ui-card__row {
  box-sizing: border-box;
}

.ui-card__row:after,
.ui-card__row:before {
  display: table;
  content: '';
}

.ui-card__row:after {
  clear: both;
}

[class^='ui-card__col-'] {
  padding: 0 0.46154em;
}

[class^='ui-card__col-'],
[class^='ui-card__logo'] {
  box-sizing: border-box;
  float: left;
}

[class^='ui-card__logo'] {
  padding: 0;
  width: 50%;
}

[class^='ui-card__logo-bank'] {
  float: right;
}

.ui-card__col-1 {
  width: 25%;
}

.ui-card__col-2 {
  width: 50%;
}

.ui-card__col-3 {
  width: 75%;
}

.ui-card__col-4 {
  width: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
}

.ui-card {
  font-size: 13px;
  height: 11.92308em;
  width: 19.84615em;
  position: relative;
}

.ui-card *,
.ui-card :after,
.ui-card :before {
  box-sizing: border-box;
}

.ui-card__container {
  background-size: contain;
  border-radius: 0.84615em;
  color: #333;
  font-family: Roboto Mono;
  overflow: hidden;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.ui-card__point {
  float: left;
  font-size: 1.30769em;
  position: relative;
  text-align: center;
  transition: color 0.3s ease-in;
  width: 0.6689em;
  background-color: #f7f7f7;
  background: linear-gradient(180deg, #999 0.1em, #fff 0.7em);
  -webkit-background-clip: text;
  background-clip: text;
  letter-spacing: 2px;
  filter: drop-shadow(0 1px 1px black);
  -webkit-text-fill-color: transparent;
}

.ui-card__point:empty {
  background: hsla(0, 9%, 93%, 0.8);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
}

.ui-card__point:empty:before {
  font-size: 0.72222em;
  border-radius: 50%;
  height: 0.46154em;
  width: 0.46154em;
  position: absolute;
  margin-left: -0.23077em;
  margin-top: -0.23077em;
  left: 50%;
  top: 50%;
  transition: background-color 0.3s ease-in;
  content: '';
}

.ui-card__point:empty:after {
  content: '*';
}

.ui-card__focus .ui-card__point:empty {
  filter: none;
}

.ui-card__focus .ui-card__point:before {
  color: #fff;
}

.ui-card__logo {
  max-width: 16.92308em;
  min-height: 3em;
}

.ui-card:not([class*='ui-card__brand-']) .ui-card__logo {
  background: #666;
  border-radius: 0.15385em;
  margin-bottom: 0;
  height: 3em;
  width: 4.46154em;
  opacity: 0.1;
}

.ui-card__logos-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ui-card__logo:before {
  content: ' ';
  display: inline-block;
  background-image: url(https://http2.mlstatic.com/frontend-assets/buyingflow-frontend-core/images/ui-card__logos-mlb-0829bc09dc.svg);
  background-repeat: no-repeat;
  background-size: 15.153846153846153em 44.76923076923077em;
  vertical-align: middle;
  position: absolute;
}

.ui-card__brand-amex .ui-card__logo:before {
  background-position: -0.07692307692307693em -0.07692307692307693em;
  width: 3.4615384615384617em;
  height: 3.4615384615384617em;
}

.ui-card__brand-debelo .ui-card__logo:before {
  background-position: -0.07692307692307693em -3.6923076923076925em;
  width: 5.923076923076923em;
  height: 2.4615384615384617em;
}

.ui-card__brand-debmaster .ui-card__logo:before {
  background-position: -0.07692307692307693em -6.3076923076923075em;
  width: 4.038461538461538em;
  height: 3.8461538461538463em;
}

.ui-card__brand-debmaster-b .ui-card__logo:before {
  background-position: -0.07692307692307693em -10.307692307692307em;
  width: 4.038461538461538em;
  height: 3.8461538461538463em;
}

.ui-card__brand-debvisa .ui-card__logo:before {
  background-position: -0.07692307692307693em -14.307692307692307em;
  width: 5em;
  height: 2.5384615384615383em;
}

.ui-card__brand-debvisa-b .ui-card__logo:before {
  background-position: -0.07692307692307693em -17em;
  width: 5em;
  height: 2.5384615384615383em;
}

.ui-card__brand-diners .ui-card__logo:before {
  background-position: -0.07692307692307693em -19.692307692307693em;
  width: 7.884615384615385em;
  height: 3em;
}

.ui-card__brand-elo .ui-card__logo:before {
  background-position: -0.07692307692307693em -22.846153846153847em;
  width: 4.230769230769231em;
  height: 2.6923076923076925em;
}

.ui-card__brand-hipercard .ui-card__logo:before {
  background-position: -0.07692307692307693em -25.692307692307693em;
  width: 5.923076923076923em;
  height: 3em;
}

.ui-card__brand-master .ui-card__logo:before {
  background-position: -0.07692307692307693em -28.846153846153847em;
  width: 4.230769230769231em;
  height: 3.076923076923077em;
}

.ui-card__brand-master-b .ui-card__logo:before,
.ui-card__brand-melicard.ui-card__brand-master .ui-card__logo:before {
  background-position: -0.07692307692307693em -32.07692307692308em;
  width: 4.230769230769231em;
  height: 3.076923076923077em;
}

.ui-card__brand-mercado-pago-card .ui-card__logo:before {
  background-position: -0.07692307692307693em -35.307692307692314em;
  width: 3.4615384615384617em;
  height: 3.076923076923077em;
}

.ui-card__brand-visa .ui-card__logo:before {
  background-position: -0.07692307692307693em -38.53846153846154em;
  width: 15em;
  height: 3em;
}

.ui-card__brand-cartao-mercado-livre.ui-card__brand-visa .ui-card__logo:before,
.ui-card__brand-visa-b .ui-card__logo:before {
  background-position: -0.07692307692307693em -41.69230769230769em;
  width: 15em;
  height: 3em;
}

.ui-card__logo-bank:before {
  content: ' ';
  display: inline-block;
  background-image: url(https://http2.mlstatic.com/frontend-assets/buyingflow-frontend-core/images/ui-card__logos-mlb-bank-3ca99b8e9b.svg);
  background-repeat: no-repeat;
  background-size: 6.076923076923077em 9.423076923076923em;
  vertical-align: middle;
  float: right;
}

.ui-card__brand-caixa .ui-card__logo-bank:before {
  background-position: -0.07692307692307693em -0.07692307692307693em;
  width: 5.923076923076923em;
  height: 2.4615384615384617em;
}

.ui-card__brand-cartao-mercado-livre .ui-card__logo-bank:before {
  background-position: -0.07692307692307693em -2.6923076923076925em;
  width: 3.769230769230769em;
  height: 0.9615384615384616em;
}

.ui-card__brand-melicard .ui-card__logo-bank:before {
  background-position: -0.07692307692307693em -3.807692307692308em;
  width: 5.769230769230769em;
  height: 2.3076923076923075em;
}

.ui-card__brand-mercado-pago .ui-card__logo-bank:before {
  background-position: -0.07692307692307693em -6.269230769230769em;
  width: 3.4615384615384617em;
  height: 3.076923076923077em;
}

.ui-card__number {
  line-height: 1.3;
  margin: 0.30769em 0 0.92308em;
}

.ui-card__number:after,
.ui-card__number:before {
  clear: both;
  content: '';
  display: block;
}

.ui-card__number-4-6-4 .ui-card__point:nth-child(4),
.ui-card__number-4-6-4 .ui-card__point:nth-child(10) {
  margin-right: calc(50% - 4.68227em);
}

.ui-card__number-4-6-4 .ui-card__point:nth-child(15),
.ui-card__number-4-6-4 .ui-card__point:nth-child(16),
.ui-card__number-4-6-4 .ui-card__point:nth-child(17),
.ui-card__number-4-6-4 .ui-card__point:nth-child(18),
.ui-card__number-4-6-4 .ui-card__point:nth-child(19) {
  display: none;
}

.ui-card__number-4-6-5 .ui-card__point:nth-child(4),
.ui-card__number-4-6-5 .ui-card__point:nth-child(10) {
  margin-right: calc(50% - 5.01672em);
}

.ui-card__number-4-6-5 .ui-card__point:nth-child(16),
.ui-card__number-4-6-5 .ui-card__point:nth-child(17),
.ui-card__number-4-6-5 .ui-card__point:nth-child(18),
.ui-card__number-4-6-5 .ui-card__point:nth-child(19) {
  display: none;
}

.ui-card__number-4-4-4-4 .ui-card__point:nth-child(4),
.ui-card__number-4-4-4-4 .ui-card__point:nth-child(8),
.ui-card__number-4-4-4-4 .ui-card__point:nth-child(12) {
  margin-right: calc(33.33333% - 3.56745em);
}

.ui-card__number-4-4-4-4 .ui-card__point:nth-child(17),
.ui-card__number-4-4-4-4 .ui-card__point:nth-child(18),
.ui-card__number-4-4-4-4 .ui-card__point:nth-child(19) {
  display: none;
}

.ui-card__number-10-5-2 .ui-card__point {
  font-size: 1.23077em;
}

.ui-card__number-10-5-2 .ui-card__point:nth-child(10),
.ui-card__number-10-5-2 .ui-card__point:nth-child(15) {
  margin-right: calc(50% - 5.68562em);
}

.ui-card__number-10-5-2 .ui-card__point:nth-child(18),
.ui-card__number-10-5-2 .ui-card__point:nth-child(19) {
  display: none;
}

.ui-card__number-10-5-3 .ui-card__point {
  font-size: 1.23077em;
}

.ui-card__number-10-5-3 .ui-card__point:nth-child(10),
.ui-card__number-10-5-3 .ui-card__point:nth-child(15) {
  margin-right: calc(50% - 6.02007em);
}

.ui-card__number-10-5-3 .ui-card__point:nth-child(19) {
  display: none;
}

.ui-card__number-9-10 .ui-card__point {
  font-size: 1.23077em;
}

.ui-card__number-9-10 .ui-card__point:nth-child(9) {
  margin-right: calc(100% - 12.70903em);
}

.ui-card__name {
  font-size: 0.92308em;
  display: block;
  overflow: hidden;
  text-transform: uppercase;
  white-space: nowrap;
  transition: color 0.3s ease-in;
  background-color: #f7f7f7;
  background-image: linear-gradient(180deg, #999 0, #fff 0.625em);
  letter-spacing: -0.5px;
  -webkit-background-clip: text;
  background-clip: text;
  filter: drop-shadow(0 1px 1px black);
  -webkit-text-fill-color: transparent;
}

.ui-card__name:empty {
  background: hsla(0, 9%, 93%, 0.8);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
}

.ui-card__name:empty:before {
  content: 'Nome e Sobrenome';
}

.ui-card__name.ui-card__focus:empty {
  filter: none;
}

[data-site*='MLB'] .ui-card__name:empty:before {
  content: 'Nome e sobrenome';
}

.ui-card__expiration > span {
  float: right;
  font-size: 0.92308em;
  text-transform: uppercase;
  transition: color 0.3s ease-in;
  background-color: #f7f7f7;
  background-image: linear-gradient(180deg, #999 0, #fff 0.625em);
  letter-spacing: -0.5px;
  -webkit-background-clip: text;
  background-clip: text;
  filter: drop-shadow(0 1px 1px black);
  -webkit-text-fill-color: transparent;
}

.ui-card__expiration > span:empty {
  background: hsla(0, 9%, 93%, 0.8);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
}

.ui-card__expiration > span:first-child:empty:before,
.ui-card__expiration > span:nth-child(2):empty:before {
  content: 'A';
}

.ui-card__expiration > span:nth-child(3):empty:after {
  content: 'M/';
}

.ui-card__expiration > span:nth-child(3):after {
  content: '/';
}

.ui-card__expiration > span:nth-child(4):empty:before {
  content: 'M';
}

.ui-card__expiration.ui-card__focus > span:empty {
  filter: none;
}

.ui-card__security {
  background: linear-gradient(234deg, #f2f2f2, #fff);
  height: 1.8em;
  line-height: 1.84615em;
  position: relative;
  vertical-align: middle;
  text-align: center;
}

.ui-card__security:before {
  content: '';
  border: 0.23077em solid #f04449;
  border-radius: 50%;
  display: block;
  position: absolute;
  left: 0.23077em;
  top: -0.61538em;
  height: 3.07692em;
  width: 3.07692em;
}

.ui-card__security .ui-card__point {
  font-size: 1em;
  width: calc(33.33333% - 0.51282em);
  color: #333;
  background: none;
  filter: none;
  -webkit-text-fill-color: #333;
}

.ui-card__security .ui-card__point:empty {
  color: #333;
}

.ui-card__security .ui-card__point:before {
  color: #333;
  font-size: 1em;
  height: 0.30769em;
  width: 0.30769em;
  margin-left: -0.15385em;
  margin-top: -0.15385em;
}

.ui-card__security .ui-card__point:first-child {
  margin-left: 0.76923em;
}

.ui-card__security-front {
  background: transparent;
  visibility: hidden;
}

.ui-card__security-front:before {
  left: -99999px;
  opacity: 0;
  transition: opacity 1s linear;
}

.ui-card__security-front .ui-card__point {
  float: right;
  font-size: 0.92308em;
  width: 0.76923em;
}

.ui-card__security-front .ui-card__point:before {
  font-size: 1.08333em;
}

.ui-card__security-front .ui-card__point:first-child {
  margin-left: 0;
}

.ui-card__brand-banamex .ui-card__security:before,
.ui-card__brand-banco-galicia .ui-card__security:before,
.ui-card__brand-banorte .ui-card__security:before,
.ui-card__brand-banregio .ui-card__security:before,
.ui-card__brand-hipercard .ui-card__security:before,
.ui-card__brand-hsbc .ui-card__security:before,
.ui-card__brand-invex .ui-card__security:before,
.ui-card__brand-nuevo-banco-de-entre-rios .ui-card__security:before,
.ui-card__brand-santander .ui-card__security:before,
.ui-card__brand-scotiabank .ui-card__security:before {
  border-color: #5a5a5a;
}

.ui-card__magnetic {
  background: rgba(0, 0, 0, 0.7);
  height: 2.84615em;
  margin: 0 -1.38462em 0.76923em;
  z-index: 1;
}

.ui-card__signature {
  margin: 0 -0.92308em 0 0;
  z-index: 1;
}

.ui-card__signature > span {
  height: 0.3em;
  display: block;
}

.ui-card__signature > span:after,
.ui-card__signature > span:before {
  content: '';
  display: block;
  height: 0.15385em;
  width: 100%;
}

.ui-card__signature > span:first-child:before {
  background-image: linear-gradient(94deg, #fff, #d3d3d3);
}

.ui-card__signature > span:first-child:after {
  background-image: linear-gradient(282deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(2):before {
  background-image: linear-gradient(95deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(2):after {
  background-image: linear-gradient(287deg, #fff, #f7f7f7 19%, #d3d3d3);
}

.ui-card__signature > span:nth-child(3):before {
  background-image: linear-gradient(93deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(3):after {
  background-image: linear-gradient(287deg, #fff, #f9f9f9 15%, #d3d3d3);
}

.ui-card__signature > span:nth-child(4):before {
  background-image: linear-gradient(94deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(4):after {
  background-image: linear-gradient(290deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(5):before {
  background-image: linear-gradient(93deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(5):after {
  background-image: linear-gradient(
    280deg,
    #fff,
    #f6f6f6 22%,
    #f6f6f6 0,
    #f6f6f6 0,
    #d3d3d3
  );
}

.ui-card__signature > span:nth-child(6):before {
  background-image: linear-gradient(92deg, #fff, #d3d3d3);
}

.ui-card__signature > span:nth-child(6):after {
  background-image: linear-gradient(282deg, #fff, #fbfbfb 10%, #d3d3d3);
}

.ui-card {
  perspective: 39.69231em;
}

.ui-card__container {
  backface-visibility: hidden;
}

.ui-card__front {
  transform: rotateY(0deg);
  z-index: 2;
}

.ui-card__back {
  transform: rotateY(-180deg);
  z-index: 1;
}

.ui-card__rotate {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
}

.ui-card__rotate-front .ui-card__front {
  animation-duration: 1s;
  animation-name: flip-front-180-0;
  transform: rotateY(0deg);
  z-index: 2;
}

.ui-card__rotate-front .ui-card__back {
  animation-duration: 1s;
  animation-name: flip-front-0-180;
  transform: rotateY(-180deg);
  z-index: 1;
}

.ui-card__rotate-back .ui-card__front {
  animation-duration: 1s;
  animation-name: flip-back-0-180;
  transform: rotateY(180deg);
  z-index: 1;
}

.ui-card__rotate-back .ui-card__back {
  animation-duration: 1s;
  animation-name: flip-back-180-0;
  transform: rotateY(0deg);
  z-index: 2;
}

@keyframes flip-front-0-180 {
  0% {
    transform: rotateY(0deg);
  }
  10% {
    transform: rotateY(5deg);
  }
  50% {
    transform: rotateY(-185deg);
  }
  to {
    transform: rotateY(-180deg);
  }
}

@keyframes flip-front-180-0 {
  0% {
    transform: rotateY(180deg);
  }
  10% {
    transform: rotateY(185deg);
  }
  50% {
    transform: rotateY(-5deg);
  }
  to {
    transform: rotateY(0deg);
  }
}

@keyframes flip-back-0-180 {
  0% {
    transform: rotateY(0deg);
  }
  10% {
    transform: rotateY(-5deg);
  }
  50% {
    transform: rotateY(185deg);
  }
  to {
    transform: rotateY(180deg);
  }
}

@keyframes flip-back-180-0 {
  0% {
    transform: rotateY(-180deg);
  }
  10% {
    transform: rotateY(-185deg);
  }
  50% {
    transform: rotateY(5deg);
  }
  to {
    transform: rotateY(0deg);
  }
}

[class*='ui-card__brand-'] .ui-card__background:before {
  animation-duration: 0.4s;
  content: '';
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -3;
  animation-name: bubble-before;
}

.ui-card__background:after,
.ui-card__background:before {
  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);
}

@keyframes bubble-before {
  0% {
    top: -9.375em;
    left: -15.625em;
    border-radius: 0 0 800% 0;
  }
  80% {
    top: 0;
    left: 0;
  }
  to {
    border-radius: 5% 0 5% 5%;
  }
}

.ui-card:not([class*='ui-card__brand-']) .ui-card__number .ui-card__point {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card:not([class*='ui-card__brand-'])
  .ui-card__number
  .ui-card__point:empty {
  color: hsla(0, 9%, 93%, 0.8);
}

.ui-card:not([class*='ui-card__brand-'])
  .ui-card__number.ui-card__focus
  > span {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card:not([class*='ui-card__brand-'])
  .ui-card__expiration.ui-card__focus
  > span,
.ui-card:not([class*='ui-card__brand-']) .ui-card__expiration > span,
.ui-card:not([class*='ui-card__brand-']) .ui-card__name,
.ui-card:not([class*='ui-card__brand-']) .ui-card__name.ui-card__focus {
  color: #666;
  filter: none;
  -webkit-text-fill-color: #666;
}

.ui-card:not([class*='ui-card__brand-']) .ui-card__background:after {
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);
}

.ui-card__background {
  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);
  z-index: -3;
}

.ui-card__background,
.ui-card__background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ui-card__background-overlay {
  z-index: -1;
}

.ui-card__background-overlay:after,
.ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.03);
}

.ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.03);
}

.ui-card__brand-visa .ui-card__background:after,
.ui-card__brand-visa .ui-card__background:before {
  background: linear-gradient(90deg, #021670, #5168d1);
}

.ui-card__brand-visa .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-visa .ui-card__background-overlay:after,
.ui-card__brand-visa .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-visa .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.09);
}

.ui-card__brand-visa .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.09);
}

.ui-card__brand-master .ui-card__background:after,
.ui-card__brand-master .ui-card__background:before {
  background: linear-gradient(90deg, #3a4e64, #5e8aa0);
}

.ui-card__brand-master .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-master .ui-card__background-overlay:after,
.ui-card__brand-master .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-master .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.09);
}

.ui-card__brand-master .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.09);
}

.ui-card__brand-amex .ui-card__background:after,
.ui-card__brand-amex .ui-card__background:before {
  background: linear-gradient(90deg, #73a299, #a8c6b2);
}

.ui-card__brand-amex .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-amex .ui-card__background-overlay:after,
.ui-card__brand-amex .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-amex .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.04);
}

.ui-card__brand-amex .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.04);
}

.ui-card__brand-debvisa .ui-card__background:after,
.ui-card__brand-debvisa .ui-card__background:before {
  background: linear-gradient(90deg, #021670, #5168d1);
}

.ui-card__brand-debvisa .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-debvisa .ui-card__background-overlay:after,
.ui-card__brand-debvisa .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-debvisa .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.09);
}

.ui-card__brand-debvisa .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.09);
}

.ui-card__brand-debmaster .ui-card__background:after,
.ui-card__brand-debmaster .ui-card__background:before {
  background: linear-gradient(90deg, #3a4e64, #5e8aa0);
}

.ui-card__brand-debmaster .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-debmaster .ui-card__background-overlay:after,
.ui-card__brand-debmaster .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-debmaster .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.09);
}

.ui-card__brand-debmaster .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.09);
}

.ui-card__brand-amex .ui-card__security {
  margin-bottom: 5px;
}

.ui-card__brand-amex .ui-card__security.ui-card__focus:before {
  content: '';
  border: 0.23077em solid #f04449;
  border-radius: 50%;
  display: block;
  right: -0.4em;
  left: initial;
  position: flex;
  width: 2.7em;
  height: 2.7em;
  top: -0.5em;
  opacity: 1;
}

.ui-card__brand-amex .ui-card__security .ui-card__point {
  font-size: 0.625em;
  -webkit-font-smoothing: auto;
  filter: none;
  -webkit-text-fill-color: hsla(0, 9%, 93%, 0.8);
}

.ui-card__brand-amex .ui-card__security .ui-card__point:empty {
  color: hsla(0, 9%, 93%, 0.8);
  filter: none;
  -webkit-text-fill-color: hsla(0, 9%, 93%, 0.8);
}

.ui-card__brand-amex.ui-card__brand-banco-patagonia
  .ui-card__security
  .ui-card__point,
.ui-card__brand-amex.ui-card__brand-banco-patagonia
  .ui-card__security
  .ui-card__point:empty {
  color: #666;
  filter: none;
  -webkit-text-fill-color: #666;
}

.ui-card__brand-amex.ui-card__brand-banco-galicia
  .ui-card__security.ui-card__focus:before,
.ui-card__brand-amex.ui-card__brand-hsbc
  .ui-card__security.ui-card__focus:before,
.ui-card__brand-amex.ui-card__brand-santander
  .ui-card__security.ui-card__focus:before {
  border-color: #5a5a5a;
}

.ui-card__brand-debelo .ui-card__background:after,
.ui-card__brand-debelo .ui-card__background:before,
.ui-card__brand-elo .ui-card__background:after,
.ui-card__brand-elo .ui-card__background:before {
  background: linear-gradient(90deg, #3f3f3f, #6a6a6a);
}

.ui-card__brand-debelo .ui-card__background-overlay,
.ui-card__brand-elo .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-debelo .ui-card__background-overlay:after,
.ui-card__brand-debelo .ui-card__background-overlay:before,
.ui-card__brand-elo .ui-card__background-overlay:after,
.ui-card__brand-elo .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-debelo .ui-card__background-overlay:before,
.ui-card__brand-elo .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.04);
}

.ui-card__brand-debelo .ui-card__background-overlay:after,
.ui-card__brand-elo .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.04);
}

.ui-card__brand-hipercard .ui-card__background:after,
.ui-card__brand-hipercard .ui-card__background:before {
  background: linear-gradient(90deg, #c62020, #fe5050);
}

.ui-card__brand-hipercard .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-hipercard .ui-card__background-overlay:after,
.ui-card__brand-hipercard .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-hipercard .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.04);
}

.ui-card__brand-hipercard .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.04);
}

.ui-card__brand-melicard .ui-card__background:after,
.ui-card__brand-melicard .ui-card__background:before {
  background: linear-gradient(90deg, #ffe000, #ffe600);
}

.ui-card__brand-melicard .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-melicard .ui-card__background-overlay:after,
.ui-card__brand-melicard .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-melicard .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.03);
}

.ui-card__brand-melicard .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.03);
}

.ui-card__brand-diners .ui-card__background:after,
.ui-card__brand-diners .ui-card__background:before {
  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);
}

.ui-card__brand-diners .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-diners .ui-card__background-overlay:after,
.ui-card__brand-diners .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-diners .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.03);
}

.ui-card__brand-diners .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.03);
}

.ui-card__brand-diners .ui-card__number .ui-card__point,
.ui-card__brand-melicard .ui-card__number .ui-card__point {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card__brand-diners .ui-card__number .ui-card__point:empty,
.ui-card__brand-melicard .ui-card__number .ui-card__point:empty {
  color: hsla(0, 9%, 93%, 0.8);
}

.ui-card__brand-diners .ui-card__number.ui-card__focus > span,
.ui-card__brand-melicard .ui-card__number.ui-card__focus > span {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card__brand-diners .ui-card__expiration.ui-card__focus > span,
.ui-card__brand-diners .ui-card__expiration > span,
.ui-card__brand-diners .ui-card__name,
.ui-card__brand-diners .ui-card__name.ui-card__focus,
.ui-card__brand-melicard .ui-card__expiration.ui-card__focus > span,
.ui-card__brand-melicard .ui-card__expiration > span,
.ui-card__brand-melicard .ui-card__name,
.ui-card__brand-melicard .ui-card__name.ui-card__focus {
  color: #666;
  filter: none;
  -webkit-text-fill-color: #666;
}

.ui-card__brand-diners .ui-card__background:after,
.ui-card__brand-melicard .ui-card__background:after {
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);
}

.ui-card__brand-cartao-mercado-livre .ui-card__number .ui-card__point {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card__brand-cartao-mercado-livre .ui-card__number .ui-card__point:empty {
  color: hsla(0, 9%, 93%, 0.8);
}

.ui-card__brand-cartao-mercado-livre .ui-card__number.ui-card__focus > span {
  background: linear-gradient(0deg, #595959, #777);
  -webkit-background-clip: text;
  background-clip: text;
  filter: none;
  -webkit-text-fill-color: transparent;
}

.ui-card__brand-cartao-mercado-livre .ui-card__expiration.ui-card__focus > span,
.ui-card__brand-cartao-mercado-livre .ui-card__expiration > span,
.ui-card__brand-cartao-mercado-livre .ui-card__name,
.ui-card__brand-cartao-mercado-livre .ui-card__name.ui-card__focus {
  color: #666;
  filter: none;
  -webkit-text-fill-color: #666;
}

.ui-card__brand-cartao-mercado-livre .ui-card__background:after {
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);
}

.ui-card__brand-cartao-mercado-livre .ui-card__background:after,
.ui-card__brand-cartao-mercado-livre .ui-card__background:before {
  background: linear-gradient(90deg, #ffe000, #ffe600);
}

.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:after,
.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.04);
}

.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.04);
}

.ui-card__brand-caixa .ui-card__background:after,
.ui-card__brand-caixa .ui-card__background:before {
  background: linear-gradient(45deg, #11309b 30%, #358dd9);
}

.ui-card__brand-caixa .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-caixa .ui-card__background-overlay:after,
.ui-card__brand-caixa .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-caixa .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.04);
}

.ui-card__brand-caixa .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.04);
}

.ui-card__brand-caixa .ui-card__security:before {
  border-color: #f04449;
}

.ui-card__brand-mercado-pago .ui-card__background:after,
.ui-card__brand-mercado-pago .ui-card__background:before {
  background: linear-gradient(90deg, #111, #232a37);
}

.ui-card__brand-mercado-pago .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-mercado-pago .ui-card__background-overlay:after,
.ui-card__brand-mercado-pago .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-mercado-pago .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.03);
}

.ui-card__brand-mercado-pago .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.03);
}

.ui-card__brand-mercado-pago-card .ui-card__background:after,
.ui-card__brand-mercado-pago-card .ui-card__background:before {
  background: linear-gradient(90deg, #111, #232a37);
}

.ui-card__brand-mercado-pago-card .ui-card__background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ui-card__brand-mercado-pago-card .ui-card__background-overlay:after,
.ui-card__brand-mercado-pago-card .ui-card__background-overlay:before {
  position: absolute;
  border-radius: 50%;
  width: 26.25em;
  height: 26.25em;
  content: ' ';
  z-index: 1;
}

.ui-card__brand-mercado-pago-card .ui-card__background-overlay:before {
  top: 0.875em;
  left: -9em;
  background: rgba(0, 0, 0, 0.03);
}

.ui-card__brand-mercado-pago-card .ui-card__background-overlay:after {
  right: -11.188em;
  top: -15.875em;
  left: 2.188em;
  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);
  background: rgba(58, 58, 58, 0.03);
}

.ui-card__brand-melicard.ui-card__brand-master .ui-card__logo-bank {
  position: absolute;
  right: 16px;
  top: 24px;
}

.ui-card__brand-caixa.ui-card__brand-debelo .ui-card__logo-bank,
.ui-card__brand-caixa.ui-card__brand-debvisa .ui-card__logo-bank {
  position: absolute;
  right: 16px;
  top: 20px;
}

.ui-card__brand-mercado-pago .ui-card__logo-bank {
  position: absolute;
  right: 16px;
  top: 17px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CreditCardDiv/CreditCardDiv.css"],"names":[],"mappings":"AAAA;;;EAGE,4BAA4B;AAC9B;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAGE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAIE,sBAAsB;AACxB;;AAEA;EAEE,wBAAwB;EAExB,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAElB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EASzB,2DAA2D;EAC3D,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EAEnB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;AACd;;AAEA;EACE,oBAAoB;EAEpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,QAAQ;EAER,yCAAyC;EAIzC,WAAW;AAHb;;AAMA;EACE,YAAY;AACd;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAEhB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mIAAmI;EACnI,4BAA4B;EAE5B,yDAAyD;EACzD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;EACjD,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,gEAAgE;EAChE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,gEAAgE;EAChE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wIAAwI;EACxI,4BAA4B;EAE5B,wDAAwD;EACxD,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gEAAgE;EAChE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EAEnB,8BAA8B;EAC9B,yBAAyB;EASzB,+DAA+D;EAC/D,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EAErB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EAEzB,8BAA8B;EAC9B,yBAAyB;EASzB,+DAA+D;EAC/D,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EAErB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,YAAY;AACd;;AAEA;EAEE,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAE/B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAEhB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EAEV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,wDAAwD;AAC1D;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,qEAAqE;AACvE;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,qEAAqE;AACvE;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,wDAAwD;AAC1D;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EASE;;;;;;;GAOC;AACH;;AAEA;EAEE,uDAAuD;AACzD;;AAEA;EAEE,qEAAqE;AACvE;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EAEE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,4BAA4B;AAC9B;;AAEA;EAEE,sBAAsB;EAEtB,gCAAgC;EAEhC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EAEE,sBAAsB;EAEtB,gCAAgC;EAEhC,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EAEE,sBAAsB;EAEtB,+BAA+B;EAE/B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EAEE,sBAAsB;EAEtB,+BAA+B;EAE/B,wBAAwB;EACxB,UAAU;AACZ;;AAqBA;EACE;IAEE,wBAAwB;EAC1B;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,2BAA2B;EAC7B;EACA;IAEE,2BAA2B;EAC7B;AACF;;AAqBA;EACE;IAEE,0BAA0B;EAC5B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,wBAAwB;EAC1B;AACF;;AAqBA;EACE;IAEE,wBAAwB;EAC1B;EACA;IAEE,yBAAyB;EAC3B;EACA;IAEE,0BAA0B;EAC5B;EACA;IAEE,0BAA0B;EAC5B;AACF;;AAqBA;EACE;IAEE,2BAA2B;EAC7B;EACA;IAEE,2BAA2B;EAC7B;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EAEE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EAEX,6BAA6B;AAC/B;;AAEA;;EAUE,oDAAoD;AACtD;;AAmBA;EACE;IACE,aAAa;IACb,eAAe;IAEf,yBAAyB;EAC3B;EACA;IACE,MAAM;IACN,OAAO;EACT;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EASE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAWE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;;;;EAME,WAAW;EAEX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EAEE,+CAA+C;AACjD;;AAEA;EASE,oDAAoD;EACpD,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAE/B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAE5B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAE5B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;;;;;;EAME,WAAW;EAEX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;EAYE,oDAAoD;AACtD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;;;EAIE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAUE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,WAAW;EAEX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAGE,+CAA+C;AACjD;;AAEA;EASE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EASE,gDAAgD;EAChD,6BAA6B;EAC7B,qBAAqB;EAErB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;;EAIE,WAAW;EAEX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EAEE,+CAA+C;AACjD;;AAEA;;EAUE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAGE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAUE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;;EAUE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAElB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gDAAgD;EAChD,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX","sourcesContent":["// Cartao\n\n.ui-card__container {\n  padding: 1.07692em 0.61538em;\n}\n\n.ui-card__row {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.ui-card__row:after,\n.ui-card__row:before {\n  display: table;\n  content: '';\n}\n\n.ui-card__row:after {\n  clear: both;\n}\n\n[class^='ui-card__col-'] {\n  padding: 0 0.46154em;\n}\n\n[class^='ui-card__col-'],\n[class^='ui-card__logo'] {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  float: left;\n}\n\n[class^='ui-card__logo'] {\n  padding: 0;\n  width: 50%;\n}\n\n[class^='ui-card__logo-bank'] {\n  float: right;\n}\n\n.ui-card__col-1 {\n  width: 25%;\n}\n\n.ui-card__col-2 {\n  width: 50%;\n}\n\n.ui-card__col-3 {\n  width: 75%;\n}\n\n.ui-card__col-4 {\n  width: 100%;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n}\n\n.ui-card {\n  font-size: 13px;\n  height: 11.92308em;\n  width: 19.84615em;\n  position: relative;\n}\n\n.ui-card *,\n.ui-card :after,\n.ui-card :before {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.ui-card__container {\n  -webkit-background-size: contain;\n  background-size: contain;\n  -webkit-border-radius: 0.84615em;\n  border-radius: 0.84615em;\n  color: #333;\n  font-family: Roboto Mono;\n  overflow: hidden;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 0;\n}\n\n.ui-card__point {\n  float: left;\n  font-size: 1.30769em;\n  position: relative;\n  text-align: center;\n  -webkit-transition: color 0.3s ease-in;\n  transition: color 0.3s ease-in;\n  width: 0.6689em;\n  background-color: #f7f7f7;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0.1em, #999),\n    color-stop(0.7em, #fff)\n  );\n  background: -webkit-linear-gradient(top, #999 0.1em, #fff 0.7em);\n  background: linear-gradient(180deg, #999 0.1em, #fff 0.7em);\n  -webkit-background-clip: text;\n  background-clip: text;\n  letter-spacing: 2px;\n  -webkit-filter: drop-shadow(0 1px 1px #000);\n  filter: drop-shadow(0 1px 1px black);\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__point:empty {\n  background: hsla(0, 9%, 93%, 0.8);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n}\n\n.ui-card__point:empty:before {\n  font-size: 0.72222em;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  height: 0.46154em;\n  width: 0.46154em;\n  position: absolute;\n  margin-left: -0.23077em;\n  margin-top: -0.23077em;\n  left: 50%;\n  top: 50%;\n  -webkit-transition: background-color 0.3s ease-in;\n  transition: background-color 0.3s ease-in;\n}\n\n.ui-card__point:empty:before {\n  content: '';\n}\n\n.ui-card__point:empty:after {\n  content: '*';\n}\n\n.ui-card__focus .ui-card__point:empty {\n  -webkit-filter: none;\n  filter: none;\n}\n\n.ui-card__focus .ui-card__point:before {\n  color: #fff;\n}\n\n.ui-card__logo {\n  max-width: 16.92308em;\n  min-height: 3em;\n}\n\n.ui-card:not([class*='ui-card__brand-']) .ui-card__logo {\n  background: #666;\n  -webkit-border-radius: 0.15385em;\n  border-radius: 0.15385em;\n  margin-bottom: 0;\n  height: 3em;\n  width: 4.46154em;\n  opacity: 0.1;\n}\n\n.ui-card__logos-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.ui-card__logo:before {\n  content: ' ';\n  display: inline-block;\n  background-image: url(https://http2.mlstatic.com/frontend-assets/buyingflow-frontend-core/images/ui-card__logos-mlb-0829bc09dc.svg);\n  background-repeat: no-repeat;\n  -webkit-background-size: 15.153846153846153em 44.76923076923077em;\n  background-size: 15.153846153846153em 44.76923076923077em;\n  vertical-align: middle;\n  position: absolute;\n}\n\n.ui-card__brand-amex .ui-card__logo:before {\n  background-position: -0.07692307692307693em -0.07692307692307693em;\n  width: 3.4615384615384617em;\n  height: 3.4615384615384617em;\n}\n\n.ui-card__brand-debelo .ui-card__logo:before {\n  background-position: -0.07692307692307693em -3.6923076923076925em;\n  width: 5.923076923076923em;\n  height: 2.4615384615384617em;\n}\n\n.ui-card__brand-debmaster .ui-card__logo:before {\n  background-position: -0.07692307692307693em -6.3076923076923075em;\n  width: 4.038461538461538em;\n  height: 3.8461538461538463em;\n}\n\n.ui-card__brand-debmaster-b .ui-card__logo:before {\n  background-position: -0.07692307692307693em -10.307692307692307em;\n  width: 4.038461538461538em;\n  height: 3.8461538461538463em;\n}\n\n.ui-card__brand-debvisa .ui-card__logo:before {\n  background-position: -0.07692307692307693em -14.307692307692307em;\n  width: 5em;\n  height: 2.5384615384615383em;\n}\n\n.ui-card__brand-debvisa-b .ui-card__logo:before {\n  background-position: -0.07692307692307693em -17em;\n  width: 5em;\n  height: 2.5384615384615383em;\n}\n\n.ui-card__brand-diners .ui-card__logo:before {\n  background-position: -0.07692307692307693em -19.692307692307693em;\n  width: 7.884615384615385em;\n  height: 3em;\n}\n\n.ui-card__brand-elo .ui-card__logo:before {\n  background-position: -0.07692307692307693em -22.846153846153847em;\n  width: 4.230769230769231em;\n  height: 2.6923076923076925em;\n}\n\n.ui-card__brand-hipercard .ui-card__logo:before {\n  background-position: -0.07692307692307693em -25.692307692307693em;\n  width: 5.923076923076923em;\n  height: 3em;\n}\n\n.ui-card__brand-master .ui-card__logo:before {\n  background-position: -0.07692307692307693em -28.846153846153847em;\n  width: 4.230769230769231em;\n  height: 3.076923076923077em;\n}\n\n.ui-card__brand-master-b .ui-card__logo:before,\n.ui-card__brand-melicard.ui-card__brand-master .ui-card__logo:before {\n  background-position: -0.07692307692307693em -32.07692307692308em;\n  width: 4.230769230769231em;\n  height: 3.076923076923077em;\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__logo:before {\n  background-position: -0.07692307692307693em -35.307692307692314em;\n  width: 3.4615384615384617em;\n  height: 3.076923076923077em;\n}\n\n.ui-card__brand-visa .ui-card__logo:before {\n  background-position: -0.07692307692307693em -38.53846153846154em;\n  width: 15em;\n  height: 3em;\n}\n\n.ui-card__brand-cartao-mercado-livre.ui-card__brand-visa .ui-card__logo:before,\n.ui-card__brand-visa-b .ui-card__logo:before {\n  background-position: -0.07692307692307693em -41.69230769230769em;\n  width: 15em;\n  height: 3em;\n}\n\n.ui-card__logo-bank:before {\n  content: ' ';\n  display: inline-block;\n  background-image: url(https://http2.mlstatic.com/frontend-assets/buyingflow-frontend-core/images/ui-card__logos-mlb-bank-3ca99b8e9b.svg);\n  background-repeat: no-repeat;\n  -webkit-background-size: 6.076923076923077em 9.423076923076923em;\n  background-size: 6.076923076923077em 9.423076923076923em;\n  vertical-align: middle;\n  float: right;\n}\n\n.ui-card__brand-caixa .ui-card__logo-bank:before {\n  background-position: -0.07692307692307693em -0.07692307692307693em;\n  width: 5.923076923076923em;\n  height: 2.4615384615384617em;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__logo-bank:before {\n  background-position: -0.07692307692307693em -2.6923076923076925em;\n  width: 3.769230769230769em;\n  height: 0.9615384615384616em;\n}\n\n.ui-card__brand-melicard .ui-card__logo-bank:before {\n  background-position: -0.07692307692307693em -3.807692307692308em;\n  width: 5.769230769230769em;\n  height: 2.3076923076923075em;\n}\n\n.ui-card__brand-mercado-pago .ui-card__logo-bank:before {\n  background-position: -0.07692307692307693em -6.269230769230769em;\n  width: 3.4615384615384617em;\n  height: 3.076923076923077em;\n}\n\n.ui-card__number {\n  line-height: 1.3;\n  margin: 0.30769em 0 0.92308em;\n}\n\n.ui-card__number:after,\n.ui-card__number:before {\n  clear: both;\n  content: '';\n  display: block;\n}\n\n.ui-card__number-4-6-4 .ui-card__point:nth-child(4),\n.ui-card__number-4-6-4 .ui-card__point:nth-child(10) {\n  margin-right: calc(50% - 4.68227em);\n}\n\n.ui-card__number-4-6-4 .ui-card__point:nth-child(15),\n.ui-card__number-4-6-4 .ui-card__point:nth-child(16),\n.ui-card__number-4-6-4 .ui-card__point:nth-child(17),\n.ui-card__number-4-6-4 .ui-card__point:nth-child(18),\n.ui-card__number-4-6-4 .ui-card__point:nth-child(19) {\n  display: none;\n}\n\n.ui-card__number-4-6-5 .ui-card__point:nth-child(4),\n.ui-card__number-4-6-5 .ui-card__point:nth-child(10) {\n  margin-right: calc(50% - 5.01672em);\n}\n\n.ui-card__number-4-6-5 .ui-card__point:nth-child(16),\n.ui-card__number-4-6-5 .ui-card__point:nth-child(17),\n.ui-card__number-4-6-5 .ui-card__point:nth-child(18),\n.ui-card__number-4-6-5 .ui-card__point:nth-child(19) {\n  display: none;\n}\n\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(4),\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(8),\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(12) {\n  margin-right: calc(33.33333% - 3.56745em);\n}\n\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(17),\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(18),\n.ui-card__number-4-4-4-4 .ui-card__point:nth-child(19) {\n  display: none;\n}\n\n.ui-card__number-10-5-2 .ui-card__point {\n  font-size: 1.23077em;\n}\n\n.ui-card__number-10-5-2 .ui-card__point:nth-child(10),\n.ui-card__number-10-5-2 .ui-card__point:nth-child(15) {\n  margin-right: calc(50% - 5.68562em);\n}\n\n.ui-card__number-10-5-2 .ui-card__point:nth-child(18),\n.ui-card__number-10-5-2 .ui-card__point:nth-child(19) {\n  display: none;\n}\n\n.ui-card__number-10-5-3 .ui-card__point {\n  font-size: 1.23077em;\n}\n\n.ui-card__number-10-5-3 .ui-card__point:nth-child(10),\n.ui-card__number-10-5-3 .ui-card__point:nth-child(15) {\n  margin-right: calc(50% - 6.02007em);\n}\n\n.ui-card__number-10-5-3 .ui-card__point:nth-child(19) {\n  display: none;\n}\n\n.ui-card__number-9-10 .ui-card__point {\n  font-size: 1.23077em;\n}\n\n.ui-card__number-9-10 .ui-card__point:nth-child(9) {\n  margin-right: calc(100% - 12.70903em);\n}\n\n.ui-card__name {\n  font-size: 0.92308em;\n  display: block;\n  overflow: hidden;\n  text-transform: uppercase;\n  white-space: nowrap;\n  -webkit-transition: color 0.3s ease-in;\n  transition: color 0.3s ease-in;\n  background-color: #f7f7f7;\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0, #999),\n    color-stop(0.625em, #fff)\n  );\n  background-image: -webkit-linear-gradient(top, #999, #fff 0.625em);\n  background-image: linear-gradient(180deg, #999 0, #fff 0.625em);\n  letter-spacing: -0.5px;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: drop-shadow(0 1px 1px #000);\n  filter: drop-shadow(0 1px 1px black);\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__name:empty {\n  background: hsla(0, 9%, 93%, 0.8);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n}\n\n.ui-card__name:empty:before {\n  content: 'Nome e Sobrenome';\n}\n\n.ui-card__name.ui-card__focus:empty {\n  -webkit-filter: none;\n  filter: none;\n}\n\n[data-site*='MLB'] .ui-card__name:empty:before {\n  content: 'Nome e sobrenome';\n}\n\n.ui-card__expiration > span {\n  float: right;\n  font-size: 0.92308em;\n  text-transform: uppercase;\n  -webkit-transition: color 0.3s ease-in;\n  transition: color 0.3s ease-in;\n  background-color: #f7f7f7;\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0, #999),\n    color-stop(0.625em, #fff)\n  );\n  background-image: -webkit-linear-gradient(top, #999, #fff 0.625em);\n  background-image: linear-gradient(180deg, #999 0, #fff 0.625em);\n  letter-spacing: -0.5px;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: drop-shadow(0 1px 1px #000);\n  filter: drop-shadow(0 1px 1px black);\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__expiration > span:empty {\n  background: hsla(0, 9%, 93%, 0.8);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n}\n\n.ui-card__expiration > span:first-child:empty:before,\n.ui-card__expiration > span:nth-child(2):empty:before {\n  content: 'A';\n}\n\n.ui-card__expiration > span:nth-child(3):empty:after {\n  content: 'M/';\n}\n\n.ui-card__expiration > span:nth-child(3):after {\n  content: '/';\n}\n\n.ui-card__expiration > span:nth-child(4):empty:before {\n  content: 'M';\n}\n\n.ui-card__expiration.ui-card__focus > span:empty {\n  -webkit-filter: none;\n  filter: none;\n}\n\n.ui-card__security {\n  background: -webkit-linear-gradient(216deg, #f2f2f2, #fff);\n  background: linear-gradient(234deg, #f2f2f2, #fff);\n  height: 1.8em;\n  line-height: 1.84615em;\n  position: relative;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.ui-card__security:before {\n  content: '';\n  border: 0.23077em solid #f04449;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  display: block;\n  position: absolute;\n  left: 0.23077em;\n  top: -0.61538em;\n  height: 3.07692em;\n  width: 3.07692em;\n}\n\n.ui-card__security .ui-card__point {\n  font-size: 1em;\n  width: calc(33.33333% - 0.51282em);\n  color: #333;\n  background: none;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: #333;\n}\n\n.ui-card__security .ui-card__point:empty {\n  color: #333;\n}\n\n.ui-card__security .ui-card__point:before {\n  color: #333;\n  font-size: 1em;\n  height: 0.30769em;\n  width: 0.30769em;\n  margin-left: -0.15385em;\n  margin-top: -0.15385em;\n}\n\n.ui-card__security .ui-card__point:first-child {\n  margin-left: 0.76923em;\n}\n\n.ui-card__security-front {\n  background: transparent;\n  visibility: hidden;\n}\n\n.ui-card__security-front:before {\n  left: -99999px;\n  opacity: 0;\n  -webkit-transition: opacity 1s linear;\n  transition: opacity 1s linear;\n}\n\n.ui-card__security-front .ui-card__point {\n  float: right;\n  font-size: 0.92308em;\n  width: 0.76923em;\n}\n\n.ui-card__security-front .ui-card__point:before {\n  font-size: 1.08333em;\n}\n\n.ui-card__security-front .ui-card__point:first-child {\n  margin-left: 0;\n}\n\n.ui-card__brand-banamex .ui-card__security:before,\n.ui-card__brand-banco-galicia .ui-card__security:before,\n.ui-card__brand-banorte .ui-card__security:before,\n.ui-card__brand-banregio .ui-card__security:before,\n.ui-card__brand-hipercard .ui-card__security:before,\n.ui-card__brand-hsbc .ui-card__security:before,\n.ui-card__brand-invex .ui-card__security:before,\n.ui-card__brand-nuevo-banco-de-entre-rios .ui-card__security:before,\n.ui-card__brand-santander .ui-card__security:before,\n.ui-card__brand-scotiabank .ui-card__security:before {\n  border-color: #5a5a5a;\n}\n\n.ui-card__magnetic {\n  background: rgba(0, 0, 0, 0.7);\n  height: 2.84615em;\n  margin: 0 -1.38462em 0.76923em;\n  z-index: 1;\n}\n\n.ui-card__signature {\n  margin: 0 -0.92308em 0 0;\n  z-index: 1;\n}\n\n.ui-card__signature > span {\n  height: 0.3em;\n  display: block;\n}\n\n.ui-card__signature > span:after,\n.ui-card__signature > span:before {\n  content: '';\n  display: block;\n  height: 0.15385em;\n  width: 100%;\n}\n\n.ui-card__signature > span:first-child:before {\n  background-image: -webkit-linear-gradient(356deg, #fff, #d3d3d3);\n  background-image: linear-gradient(94deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:first-child:after {\n  background-image: -webkit-linear-gradient(168deg, #fff, #d3d3d3);\n  background-image: linear-gradient(282deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(2):before {\n  background-image: -webkit-linear-gradient(355deg, #fff, #d3d3d3);\n  background-image: linear-gradient(95deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(2):after {\n  background-image: -webkit-linear-gradient(163deg, #fff, #f7f7f7 19%, #d3d3d3);\n  background-image: linear-gradient(287deg, #fff, #f7f7f7 19%, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(3):before {\n  background-image: -webkit-linear-gradient(357deg, #fff, #d3d3d3);\n  background-image: linear-gradient(93deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(3):after {\n  background-image: -webkit-linear-gradient(163deg, #fff, #f9f9f9 15%, #d3d3d3);\n  background-image: linear-gradient(287deg, #fff, #f9f9f9 15%, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(4):before {\n  background-image: -webkit-linear-gradient(356deg, #fff, #d3d3d3);\n  background-image: linear-gradient(94deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(4):after {\n  background-image: -webkit-linear-gradient(160deg, #fff, #d3d3d3);\n  background-image: linear-gradient(290deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(5):before {\n  background-image: -webkit-linear-gradient(357deg, #fff, #d3d3d3);\n  background-image: linear-gradient(93deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(5):after {\n  background-image: -webkit-linear-gradient(\n    170deg,\n    #fff,\n    #f6f6f6 22%,\n    #f6f6f6 0,\n    #f6f6f6 0,\n    #d3d3d3\n  );\n  background-image: linear-gradient(\n    280deg,\n    #fff,\n    #f6f6f6 22%,\n    #f6f6f6 0,\n    #f6f6f6 0,\n    #d3d3d3\n  );\n}\n\n.ui-card__signature > span:nth-child(6):before {\n  background-image: -webkit-linear-gradient(358deg, #fff, #d3d3d3);\n  background-image: linear-gradient(92deg, #fff, #d3d3d3);\n}\n\n.ui-card__signature > span:nth-child(6):after {\n  background-image: -webkit-linear-gradient(168deg, #fff, #fbfbfb 10%, #d3d3d3);\n  background-image: linear-gradient(282deg, #fff, #fbfbfb 10%, #d3d3d3);\n}\n\n.ui-card {\n  -webkit-perspective: 39.69231em;\n  perspective: 39.69231em;\n}\n\n.ui-card__container {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.ui-card__front {\n  -webkit-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n  z-index: 2;\n}\n\n.ui-card__back {\n  -webkit-transform: rotateY(-180deg);\n  transform: rotateY(-180deg);\n  z-index: 1;\n}\n\n.ui-card__rotate {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n}\n\n.ui-card__rotate-front .ui-card__front {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-name: flip-front-180-0;\n  animation-name: flip-front-180-0;\n  -webkit-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n  z-index: 2;\n}\n\n.ui-card__rotate-front .ui-card__back {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-name: flip-front-0-180;\n  animation-name: flip-front-0-180;\n  -webkit-transform: rotateY(-180deg);\n  transform: rotateY(-180deg);\n  z-index: 1;\n}\n\n.ui-card__rotate-back .ui-card__front {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-name: flip-back-0-180;\n  animation-name: flip-back-0-180;\n  -webkit-transform: rotateY(180deg);\n  transform: rotateY(180deg);\n  z-index: 1;\n}\n\n.ui-card__rotate-back .ui-card__back {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-name: flip-back-180-0;\n  animation-name: flip-back-180-0;\n  -webkit-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n  z-index: 2;\n}\n\n@-webkit-keyframes flip-front-0-180 {\n  0% {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  10% {\n    -webkit-transform: rotateY(5deg);\n    transform: rotateY(5deg);\n  }\n  50% {\n    -webkit-transform: rotateY(-185deg);\n    transform: rotateY(-185deg);\n  }\n  to {\n    -webkit-transform: rotateY(-180deg);\n    transform: rotateY(-180deg);\n  }\n}\n\n@keyframes flip-front-0-180 {\n  0% {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  10% {\n    -webkit-transform: rotateY(5deg);\n    transform: rotateY(5deg);\n  }\n  50% {\n    -webkit-transform: rotateY(-185deg);\n    transform: rotateY(-185deg);\n  }\n  to {\n    -webkit-transform: rotateY(-180deg);\n    transform: rotateY(-180deg);\n  }\n}\n\n@-webkit-keyframes flip-front-180-0 {\n  0% {\n    -webkit-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n  }\n  10% {\n    -webkit-transform: rotateY(185deg);\n    transform: rotateY(185deg);\n  }\n  50% {\n    -webkit-transform: rotateY(-5deg);\n    transform: rotateY(-5deg);\n  }\n  to {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n@keyframes flip-front-180-0 {\n  0% {\n    -webkit-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n  }\n  10% {\n    -webkit-transform: rotateY(185deg);\n    transform: rotateY(185deg);\n  }\n  50% {\n    -webkit-transform: rotateY(-5deg);\n    transform: rotateY(-5deg);\n  }\n  to {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n@-webkit-keyframes flip-back-0-180 {\n  0% {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  10% {\n    -webkit-transform: rotateY(-5deg);\n    transform: rotateY(-5deg);\n  }\n  50% {\n    -webkit-transform: rotateY(185deg);\n    transform: rotateY(185deg);\n  }\n  to {\n    -webkit-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n  }\n}\n\n@keyframes flip-back-0-180 {\n  0% {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  10% {\n    -webkit-transform: rotateY(-5deg);\n    transform: rotateY(-5deg);\n  }\n  50% {\n    -webkit-transform: rotateY(185deg);\n    transform: rotateY(185deg);\n  }\n  to {\n    -webkit-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n  }\n}\n\n@-webkit-keyframes flip-back-180-0 {\n  0% {\n    -webkit-transform: rotateY(-180deg);\n    transform: rotateY(-180deg);\n  }\n  10% {\n    -webkit-transform: rotateY(-185deg);\n    transform: rotateY(-185deg);\n  }\n  50% {\n    -webkit-transform: rotateY(5deg);\n    transform: rotateY(5deg);\n  }\n  to {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n@keyframes flip-back-180-0 {\n  0% {\n    -webkit-transform: rotateY(-180deg);\n    transform: rotateY(-180deg);\n  }\n  10% {\n    -webkit-transform: rotateY(-185deg);\n    transform: rotateY(-185deg);\n  }\n  50% {\n    -webkit-transform: rotateY(5deg);\n    transform: rotateY(5deg);\n  }\n  to {\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n[class*='ui-card__brand-'] .ui-card__background:before {\n  -webkit-animation-duration: 0.4s;\n  animation-duration: 0.4s;\n  content: '';\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: -3;\n  -webkit-animation-name: bubble-before;\n  animation-name: bubble-before;\n}\n\n.ui-card__background:after,\n.ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#c5c5c5),\n    to(#f3f3f3)\n  );\n  background: -webkit-linear-gradient(left, #c5c5c5, #f3f3f3);\n  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);\n}\n\n@-webkit-keyframes bubble-before {\n  0% {\n    top: -9.375em;\n    left: -15.625em;\n    -webkit-border-radius: 0 0 800% 0;\n    border-radius: 0 0 800% 0;\n  }\n  80% {\n    top: 0;\n    left: 0;\n  }\n  to {\n    -webkit-border-radius: 5% 0 5% 5%;\n    border-radius: 5% 0 5% 5%;\n  }\n}\n\n@keyframes bubble-before {\n  0% {\n    top: -9.375em;\n    left: -15.625em;\n    -webkit-border-radius: 0 0 800% 0;\n    border-radius: 0 0 800% 0;\n  }\n  80% {\n    top: 0;\n    left: 0;\n  }\n  to {\n    -webkit-border-radius: 5% 0 5% 5%;\n    border-radius: 5% 0 5% 5%;\n  }\n}\n\n.ui-card:not([class*='ui-card__brand-']) .ui-card__number .ui-card__point {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card:not([class*='ui-card__brand-'])\n  .ui-card__number\n  .ui-card__point:empty {\n  color: hsla(0, 9%, 93%, 0.8);\n}\n\n.ui-card:not([class*='ui-card__brand-'])\n  .ui-card__number.ui-card__focus\n  > span {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card:not([class*='ui-card__brand-'])\n  .ui-card__expiration.ui-card__focus\n  > span,\n.ui-card:not([class*='ui-card__brand-']) .ui-card__expiration > span,\n.ui-card:not([class*='ui-card__brand-']) .ui-card__name,\n.ui-card:not([class*='ui-card__brand-']) .ui-card__name.ui-card__focus {\n  color: #666;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: #666;\n}\n\n.ui-card:not([class*='ui-card__brand-']) .ui-card__background:after {\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n}\n\n.ui-card__background {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#c5c5c5),\n    to(#f3f3f3)\n  );\n  background: -webkit-linear-gradient(left, #c5c5c5, #f3f3f3);\n  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);\n  z-index: -3;\n}\n\n.ui-card__background,\n.ui-card__background-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ui-card__background-overlay {\n  z-index: -1;\n}\n\n.ui-card__background-overlay:after,\n.ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.03);\n}\n\n.ui-card__brand-visa .ui-card__background:after,\n.ui-card__brand-visa .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#021670),\n    to(#5168d1)\n  );\n  background: -webkit-linear-gradient(left, #021670, #5168d1);\n  background: linear-gradient(90deg, #021670, #5168d1);\n}\n\n.ui-card__brand-visa .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-visa .ui-card__background-overlay:after,\n.ui-card__brand-visa .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-visa .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.09);\n}\n\n.ui-card__brand-visa .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.09);\n}\n\n.ui-card__brand-master .ui-card__background:after,\n.ui-card__brand-master .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#3a4e64),\n    to(#5e8aa0)\n  );\n  background: -webkit-linear-gradient(left, #3a4e64, #5e8aa0);\n  background: linear-gradient(90deg, #3a4e64, #5e8aa0);\n}\n\n.ui-card__brand-master .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-master .ui-card__background-overlay:after,\n.ui-card__brand-master .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-master .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.09);\n}\n\n.ui-card__brand-master .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.09);\n}\n\n.ui-card__brand-amex .ui-card__background:after,\n.ui-card__brand-amex .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#73a299),\n    to(#a8c6b2)\n  );\n  background: -webkit-linear-gradient(left, #73a299, #a8c6b2);\n  background: linear-gradient(90deg, #73a299, #a8c6b2);\n}\n\n.ui-card__brand-amex .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-amex .ui-card__background-overlay:after,\n.ui-card__brand-amex .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-amex .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.ui-card__brand-amex .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.04);\n}\n\n.ui-card__brand-debvisa .ui-card__background:after,\n.ui-card__brand-debvisa .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#021670),\n    to(#5168d1)\n  );\n  background: -webkit-linear-gradient(left, #021670, #5168d1);\n  background: linear-gradient(90deg, #021670, #5168d1);\n}\n\n.ui-card__brand-debvisa .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-debvisa .ui-card__background-overlay:after,\n.ui-card__brand-debvisa .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-debvisa .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.09);\n}\n\n.ui-card__brand-debvisa .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.09);\n}\n\n.ui-card__brand-debmaster .ui-card__background:after,\n.ui-card__brand-debmaster .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#3a4e64),\n    to(#5e8aa0)\n  );\n  background: -webkit-linear-gradient(left, #3a4e64, #5e8aa0);\n  background: linear-gradient(90deg, #3a4e64, #5e8aa0);\n}\n\n.ui-card__brand-debmaster .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-debmaster .ui-card__background-overlay:after,\n.ui-card__brand-debmaster .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-debmaster .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.09);\n}\n\n.ui-card__brand-debmaster .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.09);\n}\n\n.ui-card__brand-amex .ui-card__security {\n  margin-bottom: 5px;\n}\n\n.ui-card__brand-amex .ui-card__security.ui-card__focus:before {\n  content: '';\n  border: 0.23077em solid #f04449;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  display: block;\n  right: -0.4em;\n  left: initial;\n  position: flex;\n  width: 2.7em;\n  height: 2.7em;\n  top: -0.5em;\n  opacity: 1;\n}\n\n.ui-card__brand-amex .ui-card__security .ui-card__point {\n  font-size: 0.625em;\n  -webkit-font-smoothing: auto;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: hsla(0, 9%, 93%, 0.8);\n}\n\n.ui-card__brand-amex .ui-card__security .ui-card__point:empty {\n  color: hsla(0, 9%, 93%, 0.8);\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: hsla(0, 9%, 93%, 0.8);\n}\n\n.ui-card__brand-amex.ui-card__brand-banco-patagonia\n  .ui-card__security\n  .ui-card__point,\n.ui-card__brand-amex.ui-card__brand-banco-patagonia\n  .ui-card__security\n  .ui-card__point:empty {\n  color: #666;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: #666;\n}\n\n.ui-card__brand-amex.ui-card__brand-banco-galicia\n  .ui-card__security.ui-card__focus:before,\n.ui-card__brand-amex.ui-card__brand-hsbc\n  .ui-card__security.ui-card__focus:before,\n.ui-card__brand-amex.ui-card__brand-santander\n  .ui-card__security.ui-card__focus:before {\n  border-color: #5a5a5a;\n}\n\n.ui-card__brand-debelo .ui-card__background:after,\n.ui-card__brand-debelo .ui-card__background:before,\n.ui-card__brand-elo .ui-card__background:after,\n.ui-card__brand-elo .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#3f3f3f),\n    to(#6a6a6a)\n  );\n  background: -webkit-linear-gradient(left, #3f3f3f, #6a6a6a);\n  background: linear-gradient(90deg, #3f3f3f, #6a6a6a);\n}\n\n.ui-card__brand-debelo .ui-card__background-overlay,\n.ui-card__brand-elo .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-debelo .ui-card__background-overlay:after,\n.ui-card__brand-debelo .ui-card__background-overlay:before,\n.ui-card__brand-elo .ui-card__background-overlay:after,\n.ui-card__brand-elo .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-debelo .ui-card__background-overlay:before,\n.ui-card__brand-elo .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.ui-card__brand-debelo .ui-card__background-overlay:after,\n.ui-card__brand-elo .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.04);\n}\n\n.ui-card__brand-hipercard .ui-card__background:after,\n.ui-card__brand-hipercard .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#c62020),\n    to(#fe5050)\n  );\n  background: -webkit-linear-gradient(left, #c62020, #fe5050);\n  background: linear-gradient(90deg, #c62020, #fe5050);\n}\n\n.ui-card__brand-hipercard .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-hipercard .ui-card__background-overlay:after,\n.ui-card__brand-hipercard .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-hipercard .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.ui-card__brand-hipercard .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.04);\n}\n\n.ui-card__brand-melicard .ui-card__background:after,\n.ui-card__brand-melicard .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#ffe000),\n    to(#ffe600)\n  );\n  background: -webkit-linear-gradient(left, #ffe000, #ffe600);\n  background: linear-gradient(90deg, #ffe000, #ffe600);\n}\n\n.ui-card__brand-melicard .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-melicard .ui-card__background-overlay:after,\n.ui-card__brand-melicard .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-melicard .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ui-card__brand-melicard .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.03);\n}\n\n.ui-card__brand-diners .ui-card__background:after,\n.ui-card__brand-diners .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#c5c5c5),\n    to(#f3f3f3)\n  );\n  background: -webkit-linear-gradient(left, #c5c5c5, #f3f3f3);\n  background: linear-gradient(90deg, #c5c5c5, #f3f3f3);\n}\n\n.ui-card__brand-diners .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-diners .ui-card__background-overlay:after,\n.ui-card__brand-diners .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-diners .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ui-card__brand-diners .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.03);\n}\n\n.ui-card__brand-diners .ui-card__number .ui-card__point,\n.ui-card__brand-melicard .ui-card__number .ui-card__point {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__brand-diners .ui-card__number .ui-card__point:empty,\n.ui-card__brand-melicard .ui-card__number .ui-card__point:empty {\n  color: hsla(0, 9%, 93%, 0.8);\n}\n\n.ui-card__brand-diners .ui-card__number.ui-card__focus > span,\n.ui-card__brand-melicard .ui-card__number.ui-card__focus > span {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__brand-diners .ui-card__expiration.ui-card__focus > span,\n.ui-card__brand-diners .ui-card__expiration > span,\n.ui-card__brand-diners .ui-card__name,\n.ui-card__brand-diners .ui-card__name.ui-card__focus,\n.ui-card__brand-melicard .ui-card__expiration.ui-card__focus > span,\n.ui-card__brand-melicard .ui-card__expiration > span,\n.ui-card__brand-melicard .ui-card__name,\n.ui-card__brand-melicard .ui-card__name.ui-card__focus {\n  color: #666;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: #666;\n}\n\n.ui-card__brand-diners .ui-card__background:after,\n.ui-card__brand-melicard .ui-card__background:after {\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__number .ui-card__point {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__number .ui-card__point:empty {\n  color: hsla(0, 9%, 93%, 0.8);\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__number.ui-card__focus > span {\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#595959),\n    to(#777)\n  );\n  background: -webkit-linear-gradient(bottom, #595959, #777);\n  background: linear-gradient(0deg, #595959, #777);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: transparent;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__expiration.ui-card__focus > span,\n.ui-card__brand-cartao-mercado-livre .ui-card__expiration > span,\n.ui-card__brand-cartao-mercado-livre .ui-card__name,\n.ui-card__brand-cartao-mercado-livre .ui-card__name.ui-card__focus {\n  color: #666;\n  -webkit-filter: none;\n  filter: none;\n  -webkit-text-fill-color: #666;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background:after {\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.3);\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background:after,\n.ui-card__brand-cartao-mercado-livre .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#ffe000),\n    to(#ffe600)\n  );\n  background: -webkit-linear-gradient(left, #ffe000, #ffe600);\n  background: linear-gradient(90deg, #ffe000, #ffe600);\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:after,\n.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.ui-card__brand-cartao-mercado-livre .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.04);\n}\n\n.ui-card__brand-caixa .ui-card__background:after,\n.ui-card__brand-caixa .ui-card__background:before {\n  background: -webkit-linear-gradient(45deg, #11309b 30%, #358dd9);\n  background: linear-gradient(45deg, #11309b 30%, #358dd9);\n}\n\n.ui-card__brand-caixa .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-caixa .ui-card__background-overlay:after,\n.ui-card__brand-caixa .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-caixa .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.ui-card__brand-caixa .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.04);\n}\n\n.ui-card__brand-caixa .ui-card__security:before {\n  border-color: #f04449;\n}\n\n.ui-card__brand-mercado-pago .ui-card__background:after,\n.ui-card__brand-mercado-pago .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#111),\n    to(#232a37)\n  );\n  background: -webkit-linear-gradient(left, #111, #232a37);\n  background: linear-gradient(90deg, #111, #232a37);\n}\n\n.ui-card__brand-mercado-pago .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-mercado-pago .ui-card__background-overlay:after,\n.ui-card__brand-mercado-pago .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-mercado-pago .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ui-card__brand-mercado-pago .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.03);\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__background:after,\n.ui-card__brand-mercado-pago-card .ui-card__background:before {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(#111),\n    to(#232a37)\n  );\n  background: -webkit-linear-gradient(left, #111, #232a37);\n  background: linear-gradient(90deg, #111, #232a37);\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__background-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__background-overlay:after,\n.ui-card__brand-mercado-pago-card .ui-card__background-overlay:before {\n  position: absolute;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  width: 26.25em;\n  height: 26.25em;\n  content: ' ';\n  z-index: 1;\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__background-overlay:before {\n  top: 0.875em;\n  left: -9em;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ui-card__brand-mercado-pago-card .ui-card__background-overlay:after {\n  right: -11.188em;\n  top: -15.875em;\n  left: 2.188em;\n  -webkit-box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  box-shadow: -1px 1px 1px hsla(0, 0%, 100%, 0.12);\n  background: rgba(58, 58, 58, 0.03);\n}\n\n.ui-card__brand-melicard.ui-card__brand-master .ui-card__logo-bank {\n  position: absolute;\n  right: 16px;\n  top: 24px;\n}\n\n.ui-card__brand-caixa.ui-card__brand-debelo .ui-card__logo-bank,\n.ui-card__brand-caixa.ui-card__brand-debvisa .ui-card__logo-bank {\n  position: absolute;\n  right: 16px;\n  top: 20px;\n}\n\n.ui-card__brand-mercado-pago .ui-card__logo-bank {\n  position: absolute;\n  right: 16px;\n  top: 17px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
